"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LengthUnit = void 0;
exports.LengthUnit = {
    In: 'in',
    Cm: 'cm',
    Mm: 'mm',
    M: 'm'
};
//# sourceMappingURL=length-unit.js.map